import { RootRoute } from "#src/routes/root";
import { RoutePath } from "#src/utils/route";

export const AnnotationDetailRoutePath = RootRoute.concat(
  new RoutePath({
    path: "/ctr-annotation",
    title: "Annotation Details",
    isPresentational: false,
  })
);
